import { defineMessages } from 'react-intl';

const translations = {
  formStep: {
    connect: {
      description: {
        id: 'pages.profile.form.steps.connect.description',
        defaultMessage:
          "Download the Authenticator app from the Play Store for Android devices or the App Store for IOS devices. Open the app and tap the plus icon. Now select 'scan a barcode' and scan the QR-code below.",
        description: 'description of the connect step in the 2fa form',
      },
      instruction: {
        id: 'pages.profile.form.steps.connect.instruction',
        defaultMessage:
          'After scanning the QR-code, enter the six digit number from the Authenticator app on your device.',
        description: 'instruction of the connect step in the 2fa form',
      },
    },
  },
  errors: {
    unableToVerify: {
      id: 'errors.response.unableToVerify2fa',
      defaultMessage: 'Unable to verify with given code',
      description: 'error message when the otp verify request fails',
    },
  },
  fields: {
    code: {
      label: {
        id: 'properties.code',
        defaultMessage: 'code',
        description: 'label of the code form field',
      },
    },
  },
  formActions: {
    verify: {
      id: 'formActions.verify',
      defaultMessage: 'Verify',
      description: 'label of the verify button',
    },
  },
};

export default defineMessages(translations);
